import { useState } from "react";

const styles = ["Classic", "Study", "Analytical", "Presentation"];

export default function StepReportStyle({ onNext, onBack, formData }) {
  const [style, setStyle] = useState(formData.reportStyle || "");

  return (
    <div>
      <h2 className="text-xl font-semibold mb-2">Choose Report Style/Format</h2>
      <select
        className="w-full p-2 border rounded mb-4"
        value={style}
        onChange={e => setStyle(e.target.value)}
      >
        <option value="">Select a style...</option>
        {styles.map(s => (
          <option key={s} value={s}>{s}</option>
        ))}
      </select>
      <div className="flex gap-2 mt-4">
        <button className="btn btn-secondary" onClick={onBack}>Back</button>
        <button className="btn btn-primary" disabled={!style} onClick={() => onNext({ reportStyle: style })}>
          Next
        </button>
      </div>
    </div>
  );
}